export const getPostDraftHydrationAction = (input: {
  postId: string;
  hydratedPostId: string | null;
  lastServerDraftKey: string | null;
  nextServerDraftKey: string | null;
  currentClientDraftKey?: string | null;
}) => {
  if (input.hydratedPostId !== input.postId) {
    return "hydrate" as const;
  }

  if (input.lastServerDraftKey !== input.nextServerDraftKey) {
    if (input.currentClientDraftKey === input.nextServerDraftKey) {
      return "acknowledge" as const;
    }

    if (
      input.currentClientDraftKey !== undefined &&
      input.currentClientDraftKey !== input.lastServerDraftKey
    ) {
      return "preserve_local" as const;
    }

    return "hydrate" as const;
  }

  return "ignore" as const;
};
